import * as React from 'react'
import { Layout } from 'react-admin'
import Menu from './Menu'
import MyAppBar from './MyAppBar'
import { env } from '../env'
import MfaSetupDialog from '../components/auth/MfaSetupDialog'

const MfhLayout = (props) => (
  <Layout {...props} menu={Menu} appBar={MyAppBar}>
    {env !== 'prod' && <div className="version-banner">{env} version</div>}
    {props.children}
    <MfaSetupDialog />
  </Layout>
)

export default MfhLayout
